var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestmentliquidation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63457 13.8134C3.51622 13.5997 1.15306 10.8887 1.36679 7.77038C1.58051 4.65203 4.29143 2.28887 7.40979 2.5026C9.86035 2.67055 11.9128 4.38106 12.5172 6.75931C12.5834 7.01941 12.426 7.28385 12.166 7.34973C11.9061 7.41689 11.6414 7.25861 11.5756 6.99853C11.0745 5.02846 9.37385 3.61126 7.34334 3.4721C4.75959 3.29501 2.51337 5.25309 2.33628 7.83683C2.1592 10.4206 4.11727 12.6668 6.70102 12.8439C7.3625 12.8892 8.00664 12.7989 8.61517 12.5759C8.86694 12.4831 9.14597 12.6126 9.2384 12.8646C9.33086 13.1164 9.20171 13.3955 8.94964 13.4879C8.21228 13.7585 7.43333 13.8681 6.63457 13.8134Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.107133
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30811 5.63467H8.61553",
    stroke: "currentColor",
    strokeWidth: 0.882014,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30811 7.13516H8.61553",
    stroke: "currentColor",
    strokeWidth: 0.882014,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28637 5.63452C7.06007 5.63452 7.68735 6.35355 7.68735 7.24031C7.68735 8.12749 7.06007 8.5896 6.28637 8.5896H5.30811L7.7179 10.8367",
    stroke: "currentColor",
    strokeWidth: 0.882014,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14C11.1215 14 10 12.899 10 11.5456C10 9.60369 12.2501 8.10849 12.3459 8.04581C12.4392 7.98473 12.5608 7.98473 12.6541 8.04581C12.7499 8.10849 15 9.60369 15 11.5456C15 12.899 13.8785 14 12.5 14ZM12.5 8.6092C12.0151 8.96804 10.5556 10.1635 10.5556 11.5456C10.5556 12.5982 11.4279 13.4545 12.5 13.4545C13.5721 13.4545 14.4444 12.5982 14.4444 11.5456C14.4444 10.1635 12.9849 8.96804 12.5 8.6092Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.352 11.3327C13.2618 11.3327 13.1745 11.284 13.1297 11.1985C12.999 10.9499 12.8091 10.6879 12.5654 10.4199C12.472 10.3174 12.4795 10.1585 12.5822 10.0653C12.6847 9.97218 12.8434 9.97938 12.9367 10.0822C13.2092 10.3816 13.4235 10.6786 13.574 10.9648C13.6385 11.0875 13.5915 11.2394 13.4687 11.3038C13.4315 11.3234 13.3914 11.3327 13.352 11.3327Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.136287
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentliquidation);
export default __webpack_public_path__ + "static/media/investment liquidation.46ffb52469467bdc4f2ff7188872e83a.svg";
export { ForwardRef as ReactComponent };